import { Box, CircularProgress, styled } from '@mui/material';

const SpinnerContainer = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  zIndex: 1300,
});

export const Spinner = () => {
  return (
    <SpinnerContainer>
      <CircularProgress color="primary" />
    </SpinnerContainer>
  );
};
